import { apiClient } from './client';
import type { DatabaseSchoolsResponse, Backup } from '@/types/database';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8092';

export async function getSchoolsForDatabase(): Promise<DatabaseSchoolsResponse> {
  const response = await apiClient.get<DatabaseSchoolsResponse>('/api/databases/schools');
  return response.data;
}

export async function getSchoolBackups(schoolCode: string): Promise<Backup[]> {
  const response = await apiClient.get<Backup[]>(`/api/schools/${schoolCode}/backups`);
  return response.data;
}

export async function createSchoolBackup(
  schoolCode: string
): Promise<{ id: number; fileName: string; message: string }> {
  const response = await apiClient.post<{ id: number; fileName: string; message: string }>(
    `/api/schools/${schoolCode}/backups`
  );
  return response.data;
}

export async function deleteSchoolBackup(schoolCode: string, backupId: number): Promise<void> {
  await apiClient.delete(`/api/schools/${schoolCode}/backups/${backupId}`);
}

export function getDevDumpDownloadUrl(): string {
  return `${API_BASE_URL}/api/databases/dev-dump`;
}

export function getBackupDownloadUrl(schoolCode: string, backupId: number): string {
  return `${API_BASE_URL}/api/schools/${schoolCode}/backups/${backupId}/download`;
}

export const databasesApi = {
  getSchools: getSchoolsForDatabase,
  getBackups: getSchoolBackups,
  createBackup: createSchoolBackup,
  deleteBackup: deleteSchoolBackup,
  getDevDumpUrl: getDevDumpDownloadUrl,
  getBackupDownloadUrl,
};
